<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/84zAI7/tc-custom/9781429982559.jpg?1733024681920" alt="This image is the cover for the book Death of a Hired Man, The Mel Pickett Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death of a Hired Man, The Mel Pickett Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Eric Wright, author of the highly acclaimed Charlie Salter novels, introduced readers to Mel Pickett in <i>Buried in Stone</i> when Pickett helped the police solve a bake-shop murder. In his newest adventure, Mel Pickett, a retired police officer from Toronto, once again becomes involved in police work when a body is discovered in the cabin that he owns. <br/><br/>The day shift at the Ontario Provincial Police Station had just come on duty when they received a disturbing phone call--a homicide in a log cabin on Larch River. Sergeant Wilkie fears it's Mel Pickett who has been killed and is almost relieved when he sees that the victim is Norbert Thompson, a local "hired man" who had been renting Pickett's cabin. Just as Wilkie starts looking for a motive, Pickett arrives in town and learns of the murder. His immediate though is, was he the intended victim? <br/><br/>Sergeant Wilkie and ex-Sergeant Pickett pursue their investigations separately, but each keeps a watchful eye on the other. Wilkie's lead brings him to rural Ontario, where Thompson used to work as a "hired man" on his brother's farm. Pickett looks for the killer among all the violent men who have threatened to get him as they were led off to jail. Will they be able to catch the killer before he or she strikes again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Wright
      </h2>
      
      <p class="authorDescription body article"><P><B>Eric Wright</B> was born in England and emigrated to Canada in 1951. His first book in the series, <I>The Night the Gods Smiled,</I> won the John Creasey Award on Britain for Best First Novel. He has also won five Arthur Ellis Awards-two for short stories, two for novels, and one for Distinguished Achievement-as well as an Edgar Award for <I>The Kidnapping of Rosie Dawn</I>. In addition to the Charlie Salter series, Wright has written other mysteries as well as some non-fiction. He lives in Toronto.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33c58f72